"use client";
import clsx from "clsx";

import useSortModal from "@/lib/hooks/plpUseSortModal";

import styles from "./sort-button.module.css";

const SortButton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLButtonElement>) => {
  const { isOpen, toggleModal } = useSortModal();

  return (
    <button
      className={clsx(
        styles.sort__button,
        isOpen && styles.active,
        "uppercase",
        "underline-hover",
        className
      )}
      onClick={(e) => {
        toggleModal();
        if (props.onClick) props.onClick(e);
      }}
      {...props}
    />
  );
};

export default SortButton;
